import { render, staticRenderFns } from "./MenuMgmt.vue?vue&type=template&id=234815a6&scoped=true"
import script from "./MenuMgmt.vue?vue&type=script&lang=js"
export * from "./MenuMgmt.vue?vue&type=script&lang=js"
import style0 from "./MenuMgmt.vue?vue&type=style&index=0&id=234815a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234815a6",
  null
  
)

export default component.exports